/**
 * StatisticsHeader component displays the header section for a list of statistics.
 */

const StatisticsHeader = () => (
  <div>
    <div className='space_between right_padding'>
      <div className='bold_title'>User Statistics</div>
    </div>
  </div>
);

export default StatisticsHeader;
